
<div class="modal">
  <div class="modal-content" [style.width]="">
    <ng-content></ng-content>
  </div>
</div>
